import { Box } from "@mui/material";
import styled from "styled-components";

export const StyledBgAllJokes = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
}));